<h1 mat-dialog-title>{{ 'properties.documents.downloadDialog.title' | translate }}</h1>

<mat-dialog-content>
  <div class="row">
    <div class="col-12">
      <p class="text-muted">{{ 'properties.documents.downloadDialog.subtitle' | translate }}</p>

      <!-- One row per file: what the user calls "a document" can be several PDFs, and each one is
           asked for on its own so a failure on one does not lose the others. -->
      <div class="download-row" *ngFor="let file of files">
        <button mat-stroked-button color="primary" class="mr-2 download-btn"
          [disabled]="file.downloading" (click)="onDownload(file)"
          matTooltip="{{ 'common.cta.download' | translate }}">
          <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
          {{ 'common.cta.download' | translate }}
        </button>
        <span class="download-name">{{ file.originalName }}</span>
        <span class="text-muted ml-2">{{ sizeLabel(file) }}</span>
        <mat-spinner class="ml-2 download-spinner" diameter="18" *ngIf="file.downloading"></mat-spinner>
      </div>

      <div class="alert alert-warning" *ngIf="!files.length">
        {{ 'properties.documentsV3.downloadDialog.empty' | translate }}
      </div>
    </div>
  </div>
</mat-dialog-content>

<div class="row custom-dialog-footer">
  <!-- With "Scarica tutti" the two buttons sit at opposite ends; without it the row is unchanged -->
  <div class="col-12"
    [ngClass]="canDownloadAll ? 'd-flex justify-content-between align-items-center' : 'text-left'">
    <a mat-button (click)="onClose()" mat-raised-button mat-default class="ml-3">
      {{ 'common.cta.close' | translate }}
    </a>
    <button *ngIf="canDownloadAll" type="button" mat-raised-button color="primary" class="mr-3"
      [disabled]="zipDownloading" [attr.aria-busy]="zipDownloading" (click)="onDownloadAll()">
      <mat-spinner *ngIf="zipDownloading" diameter="18" class="download-all-spinner mr-2"></mat-spinner>
      <mat-icon *ngIf="!zipDownloading" fontSet="fal" fontIcon="fa-download" class="mr-1"></mat-icon>
      {{ 'properties.documents.downloadDialog.downloadAll' | translate }}
    </button>
  </div>
</div>
